import SectionFadeIn from "@/components/SectionFadeIn";

/**
 * Grid of vehicle-type tiles. Active tile is highlighted and tiles call
 * `onSelect(id)` when clicked.
 */
export default function VehicleTypeSelector({ types, activeId, onSelect }) {
  return (
    <SectionFadeIn>
      <section className="mt-16" data-testid="vehicle-type-section">
        <div className="max-w-2xl">
          <p className="text-[11px] tracking-[0.22em] uppercase font-semibold text-brand-gold">
            Vehicle type
          </p>
          <h2 className="mt-3 font-heading text-3xl sm:text-4xl tracking-tight text-brand-text">
            Van branding, fleet, or targeted decals
          </h2>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5">
          {types.map((item) => {
            const active = activeId === item.id;
            const cls = active
              ? "border-brand-gold bg-brand-gold/5"
              : "border-brand-border bg-brand-surface/30 hover:border-brand-gold/40";
            return (
              <button
                key={item.id}
                type="button"
                onClick={() => onSelect(item.id)}
                className={`rounded-sm border p-6 text-left transition-[border-color,color,background-color] duration-250 ${cls}`}
                data-testid={`vehicle-type-${item.id}`}
              >
                <div className="flex items-center gap-3">
                  <span className="text-brand-gold">
                    <item.icon size={18} />
                  </span>
                  <p className="text-[11px] tracking-[0.18em] uppercase font-semibold text-brand-gold">
                    {item.eyebrow}
                  </p>
                </div>
                <h3 className="mt-4 text-[20px] font-medium text-brand-text">{item.title}</h3>
                <p className="mt-3 text-[13px] leading-relaxed text-brand-text-secondary">
                  {item.description}
                </p>
                <div className="mt-5 flex flex-wrap gap-2">
                  {item.applications.map((use) => (
                    <span
                      key={use}
                      className="rounded-full border border-white/[0.08] px-3 py-1.5 text-[10px] tracking-[0.14em] uppercase text-brand-text-secondary/65"
                      data-testid={`vehicle-type-tag-${item.id}-${use.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                    >
                      {use}
                    </span>
                  ))}
                </div>
              </button>
            );
          })}
        </div>
      </section>
    </SectionFadeIn>
  );
}
